export const getChartTitle = (label: string, measurement: string) => {
  return measurement ? `${label} (${measurement})` : label;
};
